import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyDu9rBjgVZ2G7H_F3oeztY9bdlzXwJ243k",
  authDomain: "art-prompts-1e8b5.firebaseapp.com",
  databaseURL: "https://art-prompts-1e8b5.firebaseio.com",
  projectId: "art-prompts-1e8b5",
  storageBucket: "art-prompts-1e8b5.appspot.com",
  messagingSenderId: "966053346053",
  appId: "1:966053346053:web:adb3fdc572f0bed221d56c",
  measurementId: "G-9YSWGH0B7J",
};

firebase.initializeApp(firebaseConfig);
export const auth = firebase.auth();
export const firestore = firebase.firestore();

export const subscribeToMailchimp = firebase
  .functions()
  .httpsCallable("subscribeToMailchimp");

const googleProvider = new firebase.auth.GoogleAuthProvider();

export const signInWithGoogle = () => {
  auth.signInWithPopup(googleProvider);
};
